import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function HomeArticles() {
  const latestArticles = [...articles].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
          最新文章
        </h2>
        <p className="text-foreground-600 text-sm max-w-xl mx-auto">
          持续更新摄影技巧与教程，关注我们不错过每一篇干货
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {latestArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group flex flex-col sm:flex-row gap-4 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all duration-300 cursor-pointer"
          >
            <div className="sm:w-48 flex-shrink-0 aspect-[16/10] sm:aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-1 min-w-0 flex flex-col justify-center">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full font-medium">
                  {article.tags[0]}
                </span>
                <span>{article.date}</span>
                <span>{article.readTime} 分钟阅读</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 font-heading mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {article.excerpt}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}